export default __webpack_public_path__ + "static/media/bread.4873051e.jpg";